var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blurryBlob",
    viewBox: "0 0 1100 700",
    height: 700,
    width: 1100,
    style: {
      transformOrigin: "center"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur1",
    x: "-10%",
    y: "-10%",
    width: "250%",
    height: "250%",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 60,
    r: 94,
    fill: "#ff017b",
    stroke: "#a91919",
    strokeWidth: 0.5,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 24,
    r: 92,
    fill: "#ff017b",
    stroke: "#a91919",
    strokeWidth: 0.5,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 414,
    r: 32,
    fill: "#0df1ff",
    stroke: "#a91919",
    strokeWidth: 0.5,
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 176,
    r: 51,
    fill: "#ff017b",
    stroke: "#a91919",
    strokeWidth: 0.5,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 147,
    r: 79,
    fill: "#ff017b",
    stroke: "#a91919",
    strokeWidth: 0.5,
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643,
    cy: 132,
    r: 91,
    fill: "#0df1ff",
    stroke: "#a91919",
    strokeWidth: 0.5,
    style: {
      opacity: 0.5
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselWave);
export default __webpack_public_path__ + "static/media/carousel-wave.4ed560a88794d8d7ab08875acf1be6b6.svg";
export { ForwardRef as ReactComponent };